<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    extends: TableView,

    data() {
        const { key } = this.$route.params;

        return {
            key,
            pageTitle: 'Popup Items',
            backRoute: `/contents/${key}`
        };
    },

    computed: {
        labels() {
            return [
                { value: 'title', width: '150px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    value: 'updatedAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    text: 'Created by',
                    value: 'createdBy.fullName',
                    width: '150px'
                },
                {
                    text: 'Edited by',
                    value: 'editedBy.fullName',
                    width: '150px'
                },
                {
                    value: 'date',
                    width: '150px',
                    type: 'date',
                    filter: 'formatDate'
                },
                {
                    value: 'startTime',
                    width: '150px',
                    type: 'date',
                    filter: 'formatDate'
                },
                {
                    value: 'endTime',
                    width: '150px',
                    type: 'date',
                    filter: 'formatDate'
                },
                {
                    value: 'isHidden',
                    width: '150px',
                    type: 'boolean',
                    isBadge: true
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        breadcrumbs() {
            return [
                {
                    text: 'Cancer',
                    to: '/'
                },
                {
                    text: 'Pages',
                    to: '/contents'
                },
                {
                    text: 'Popup',
                    to: `/contents/${this.key}`
                },
                {
                    text: 'Popup Items',
                    active: true
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'popupItems/index',
            deleteItem: 'popupItems/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/contents/${this.key}/popup-items/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push(`/contents/${this.key}/popup-items/add`);
        }
    }
};
</script>
